import './Confirmation.scss';
import { Button } from '@mui/material';
import { CompensationVoucher, ValidationError } from '../../models/home';
import { NOTIFICATION_TYPE } from '../../constants/common';
import { useConfirmation } from './useConfirmation';
import AppNotification from '../AppCommon/AppNotification/AppNotification';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ConfirmationWIFIDialog from '../ConfirmationWIFIDialog/ConfirmationWIFIDialog'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface Props {
    compensationVouchers: CompensationVoucher[];
    isDeviceOffline: boolean;
    validationError: ValidationError;
    handleOnClickNewForm: (samePassenger: boolean) => void;
}

const Confirmation = ({compensationVouchers, isDeviceOffline, validationError, handleOnClickNewForm,}: Props) => {
    const {
        compVouchersWithCode,
        hidePopUp,
        inFlightUser,
        isNtpVoucherCode,
        voucherCount,
        handleOnClickShowNextCode,
        setHidePopUp,
        t
    } = useConfirmation({compensationVouchers});
    
    return (
        <div className="c-confirmation" id="confirmation-component">
            <ConfirmationWIFIDialog  showPopUp={hidePopUp} hidePopUp={() => setHidePopUp(false)} />
            {validationError.isError && (
                <div className="c-notification">
                    <AppNotification
                        message={
                            validationError.errorCode === 'partial_success' 
                                ? `${validationError.successCount} ${t('notifications.partial_success_first')} ${validationError.failureCount} ${t('notifications.partial_success_second')}`
                                : t('notifications.' + (typeof validationError.errorCode === 'number' ? 
                                    validationError.errorCode.toString() : 
                                    validationError.errorCode))
                        }
                        type={NOTIFICATION_TYPE.error}
                    />
                </div>
            )}
            {inFlightUser && !isNtpVoucherCode ? (
                <div>
                    {compVouchersWithCode && compVouchersWithCode.length ? (
                        <>
                            <div className="c-dialog" onClick={(e) => setHidePopUp(true)}>
                                <InfoOutlinedIcon className="c-dialog-icon" />
                                <p className="c-dialog-text">{t('labels.wifiConnectInfo')}</p>
                            </div>
                            <p className="h-title-sm">{t('labels.compensationHeader')}</p>
                            {compVouchersWithCode && compVouchersWithCode.length && compVouchersWithCode.map((voucher, i) => (
                                <div key={i} className="c-web">
                                    <p className="label">{i + 1} of {compVouchersWithCode.length} {t('labels.requested')}</p>
                                    <p className="label-code">{voucher?.code}</p>
                                </div>
                            ))}
                            <div className="c-ipad">
                                {compVouchersWithCode && compVouchersWithCode.length > 1 ? (
                                    <p className="label">
                                        {voucherCount + 1} of {compVouchersWithCode.length} requested
                                    </p>
                                ) : (
                                    <p className="label">1 requested</p>
                                )}
                                <p className="label-code">
                                    {compVouchersWithCode && compVouchersWithCode.length && compVouchersWithCode[voucherCount]?.code}
                                </p>
                                {compVouchersWithCode
                                    && compVouchersWithCode.length 
                                    && (voucherCount + 1) < compVouchersWithCode.length ? (
                                        <p className="c-next-code" onClick={handleOnClickShowNextCode}>
                                            <span className="label-next">{t('labels.next')}</span>
                                            <span className="label-next-btn">
                                                <ArrowForwardIosIcon fontSize={'large'} />
                                            </span>
                                        </p>
                                    ) : null
                                }
                            </div>
                        </>
                    ) : null}                
                </div>
            ) : isNtpVoucherCode ? (
                <div>
                    <p className="h-title">{ isDeviceOffline ? t('titles.compensationRequested') : t('titles.compensationSent') }</p>
                    <p className="label-confirmation">{ isDeviceOffline ? t('labels.compensationEmailRequested') : t('labels.compensationEmailConfirmation') }</p>
                    <div className="c-icon"><CheckCircleIcon className="icon-checked" /></div>           
                </div>
            ) : ( 
                <div>
                    {compVouchersWithCode && compVouchersWithCode.length ? (
                        <>
                            <p className="h-title">{ isDeviceOffline ? t('titles.compensationRequested') : t('titles.compensationSent') }</p>
                            <p className="label-confirmation">{ isDeviceOffline ? t('labels.compensationEmailRequested') : t('labels.compensationEmailConfirmation') }</p>
                            <div className="c-icon"><CheckCircleIcon className="icon-checked" /></div>
                        </>
                    ) : null}                    
                </div>
            )}

            <div className="c-btn">
                <Button
                    className="btn btn--primary"
                    onClick={() => handleOnClickNewForm(false)}
                >
                    {t('buttons.newRequest')}
                </Button>
                <Button 
                    className="btn btn--secondary btn--same-passenger"
                    onClick={() => handleOnClickNewForm(true)}
                >
                    {t('buttons.newForm')}
                </Button>
            </div>
        </div>
    );
};

export default Confirmation;

